import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import { useSnackbar } from "notistack";

import { CancelLessonInput, Lesson } from "@hubcapp/types";
import { HubcappGraphqlQLError } from "@hubcapp/errors";

import cancelLessonMutation from "../graph-ql/cancelLesson.graphql";
import getErrorMessage from "./errorMapping";

type CancelLessonNotesData = {
  __typename: "Mutation";
  cancelLesson: Pick<Lesson, "id" | "status">;
};

const useCancelLesson = (
  opts: MutationHookOptions<CancelLessonNotesData, CancelLessonInput> = {},
) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<CancelLessonNotesData, CancelLessonInput>(
    cancelLessonMutation,
    {
      ...opts,
      onError: e => {
        if (e.graphQLErrors) {
          e.graphQLErrors.forEach(err => {
            const errorMessage = getErrorMessage(
              (err as HubcappGraphqlQLError).errorType,
            );
            enqueueSnackbar(errorMessage, { variant: "error" });
          });
        }
      },
    },
  );
};

export default useCancelLesson;
